import React from "react";
import KeratinHairTreatmentImg from "./KeratinHairTreatmentImg";
import KeratinHairTreatmentHead from "./KeratinHairTreatmentHead";
import HairServImg from "../../HairBotox/HairServImg";
import KeratinHairTreatmentTips from "./KeratinHairTreatmentTips";
import KeratinHairTreatmentFinal from "./KeratinHairTreatmentFinal";
import BlogSideBar from "../../../BlogSideBar/BlogSideBar";
import PersonalizedFinal from "./../../../../../Images/Blog/Keratin-Hair-Treatment-in-Bangalore/saloon1.jpg";
import tenHairColorTips from "./../../../../../Images/Blog/Keratin-Hair-Treatment-in-Bangalore/saloon2.jpg";
import { Helmet } from "react-helmet";

const KeratinHairTreatment = () => {
  return (
    <div>
      <Helmet>
        <meta charSet="UTF-8" />
        <title>Keratin Hair Treatment in Bangalore | Best Keratin Service Near Me – SCENT</title>
        <meta
          name="description"
          content="Get the best keratin hair treatment in Bangalore at SCENT. Smooth, frizz-free, and shiny hair with expert care. Book your keratin service near you today."
        />
        <link
          rel="canonical"
          href="https://scentlifestyle.com/Keratin-Hair-Treatment-in-Bangalore"
        />
      </Helmet>
      <div className="blog-container">
        <div className="blog-wrapper1">
          <KeratinHairTreatmentImg />
          <KeratinHairTreatmentHead />
          <br />
          <HairServImg hairBotoxImg={PersonalizedFinal} />
          <KeratinHairTreatmentTips />
          <br />
          <HairServImg hairBotoxImg={tenHairColorTips} />
          <KeratinHairTreatmentFinal />
        </div>
        <div className="blog-wrapper2">
          <BlogSideBar />
        </div>
      </div>
    </div>
  );
};

export default KeratinHairTreatment;


